import { useCommonStore } from '@stores/common'
import { useCheckoutStore } from '@stores/checkout'

import { useCheckoutOrderApi } from '@api/orders/checkout/checkout-order.hook'

import amplitudeConfig from '@config/amplitude.json'
import { show404 } from '@utils/pages/error'

import { trackEvent } from '@tools/amplitude'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const order = to.params?.order as string | undefined
  const notifyType = (to.query.notify_type || null) as string | null
  const solidOrderId: string | null = (to?.query?.solid_order_id || null) as string | null
  const paymentIntentId: string | null = (to?.query?.payment_intent || null) as string | null

  const validOrder: boolean = typeof order === 'string'

  if (!validOrder) return show404()

  const commonStore = useCommonStore()
  const checkoutStore = useCheckoutStore()

  const orderId = Number(order)
  const validOrderId = isFinite(orderId)

  if (!validOrderId) return show404()

  checkoutStore.setNotifyType(notifyType)

  void useCheckoutOrderApi({ orderId, solidOrderId, paymentIntentId, mode: 'enter' }, {
    onStart: () => {
      commonStore.setLoading(true)
    },
    onSuccess: () => {
      trackEvent(amplitudeConfig.events.pageViewOrder, checkoutStore.getEventProps)
    },
    onFinish: () => {
      commonStore.setLoading(false)
    },
  })
})
